export const SET_USER_HASH = 'setUserHash';
export const SET_USER_FLOW_TOKEN = 'setUserFlowToken';
export const SET_USER_FLOW_IS_ENABLED = 'setUserFlowIsEnabled';
